export default function Testimonials() {
  const testimonials = [
    {
      name: 'Amara Okonkwo',
      company: '@TechStartupNG',
      avatar: 'AO',
      text: 'ACE Consultancy helped us secure a $500K grant for our tech startup. Their proposal writing expertise is unmatched. The team understood our vision and translated it into a compelling narrative that resonated with funders.',
      color: 'from-[#D4AF37] to-[#C19B2E]'
    },
    {
      name: 'David Mensah',
      company: '@GhanaRetailGroup',
      avatar: 'DM',
      text: 'The market research provided by ACE gave us the insights we needed to expand into three new markets. Their understanding of African business dynamics is exceptional.',
      color: 'from-[#8B7355] to-[#6B5344]'
    },
    {
      name: 'Fatima Hassan',
      company: '@SecureHomesKE',
      avatar: 'FH',
      text: 'Their home security consulting service helped me find the perfect property within my budget. The location assessment and security evaluation were thorough and professional.',
      color: 'from-[#D4AF37] to-[#B8941F]'
    },
    {
      name: 'James Mwangi',
      company: '@AutoTradeAfrica',
      avatar: 'JM',
      text: 'We sold 15 vehicles through their asset sales platform in just two months. The buyer-seller matching system is efficient and the transactions were secure throughout.',
      color: 'from-[#A0826D] to-[#8B6F47]'
    },
    {
      name: 'Chioma Adebayo',
      company: '@NigeriaFinTech',
      avatar: 'CA',
      text: 'ACE Consultancy recruited our entire leadership team. Their talent sourcing and screening process is meticulous, and they truly understand what we need in candidates.',
      color: 'from-[#D4AF37] to-[#C19B2E]'
    },
    {
      name: 'Mohamed Ali',
      company: '@EastAfricaVentures',
      avatar: 'MA',
      text: 'The comprehensive market research report ACE provided was instrumental in our decision to enter the Ethiopian market. Their data-driven insights gave us the confidence to invest.',
      color: 'from-[#8B7355] to-[#6B5344]'
    }
  ];

  return (
    <section id="testimonials" className="py-20 lg:py-32 bg-[#FAF6F2]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="mb-16">
          <div className="inline-block bg-[#D4AF37] text-white px-6 py-2 rounded-full text-xs font-semibold tracking-wide mb-6">
            CLIENT SUCCESS STORIES
          </div>
          <h2 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
            What Our Clients<br />
            Say About Us
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-xl transition-all duration-300"
            >
              <div className="flex items-center gap-4 mb-6">
                <div className={`w-14 h-14 flex items-center justify-center rounded-full bg-gradient-to-br ${testimonial.color} text-white font-bold text-lg`}>
                  {testimonial.avatar}
                </div>
                <div>
                  <div className="font-bold text-gray-900 text-base">{testimonial.name}</div>
                  <div className="text-sm text-gray-600">{testimonial.company}</div>
                </div>
              </div>

              <div className="relative">
                <i className="ri-double-quotes-l text-4xl text-[#D4AF37]/20 absolute -top-2 -left-2"></i>
                <p className="text-gray-700 text-sm leading-relaxed relative z-10 pl-6">
                  {testimonial.text}
                </p>
              </div>

              <div className="flex gap-1 mt-6">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#D4AF37] text-lg"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
